import * as queries from "./queries";

const HiveSignerIntegration = {
  queries,
};

export { HiveSignerIntegration };
